var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "progress-bar-container"
  }, [_c('div', {
    staticClass: "themeIconWrapper",
    attrs: {
      "id": "iconOutline"
    }
  }, [_c('img', {
    staticClass: "themeIcon",
    attrs: {
      "src": _vm.icon
    }
  })]), _c('progress-bar', {
    attrs: {
      "total-units": _vm.totalUnits,
      "completed-units": _vm.completedUnits
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }